/*** IMPORTS FROM imports-loader ***/
var global = window;

export var SESSION_STORE_KEY = '_dd_s';
//# sourceMappingURL=sessionStoreStrategy.js.map
